import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
  } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Doughnut } from 'react-chartjs-2';
import { getColorByGroup } from '../calculations/calcV2';

interface SemiCircleGraphSimpleProps {
  title: string,
  labels: string[],
  dataNow: number[],
  bgColor: string,
  height: number,
  groups: string[],
}

export const SemiCircleGraphSimple = (props: SemiCircleGraphSimpleProps) => {
    const { title, labels, dataNow, bgColor, height, groups } = props;
    const background = bgColor ?? '#333';

    const plugin = {
        id: 'background',
        beforeDraw: (chart, args, opts) => {
          if (!opts.color) {
            return;
          }
      
          const {
            ctx,
            chartArea
          } = chart;
      
          ctx.fillStyle = opts.color;
          ctx.fillRect(chartArea.left, chartArea.top, chartArea.width, chartArea.height)
        }
      }

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        plugin,
        ChartDataLabels,
        ArcElement
      );
      
      const options: any = {
        rotation: -90,
        circumference: 180,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: title,
          },
          legend: { 
            display: false
          },
          background: { color: background },

          datalabels: {
            display: true,
            color: "#fff",
            formatter: x => Math.round(x * 10)/10,
            anchor: "end",
            offset: 2,
            align: "start",
          }
        }
      };
      if (background !== '#333'){ options.animation = { duration: 0 }; }
      
      const filterIndices = dataNow.map((x, i) => x ? i : null);
      const filteredGroups = groups.filter((x, i) => filterIndices.includes(i));
      const datasets = 
      [{
        data: dataNow.filter((x, i) => filterIndices.includes(i)),
        backgroundColor: filteredGroups.map(x => getColorByGroup(x))
      }];
      const data = {
        labels: labels.filter((x, i) => filterIndices.includes(i)),
        datasets: datasets,
      };

    return (
        <div style={{backgroundColor: background, paddingTop: 60, height: height }}>
            <Doughnut options={options} data={data} />
        </div>
    )
}